module.exports = __webpack_public_path__ + "static/media/SAMATVAM-SWASTHYA-APR-JUNE-2019.c749cba9.pdf";